import React from "react";
import { Link } from "react-router-dom";

export default function FindAdventureCTR() {
  return (
    <div className="mt-12 md:mt-22 flex flex-col md:flex-row justify-between items-center gap-10">

      {/* Image Section */}
      <div className="basis-[50%]">
        <img
          src="/images/home/map.jpg"
          alt="map"
          className="w-full h-auto"
        />
      </div>

      {/* Content Section */}
      <div className="basis-[50%]">
        <h3 className="text-[#666] font-semibold text-[24px] md:text-[26px]">
          Top Rated Our Tours
        </h3>

        <p className="text-[#999999] text-[16px] md:text-[17px]">
          Discover unforgettable experiences
        </p>

        <div className="w-[45px] bg-[#ff9219] h-[2px] my-[20px]"></div>

        <p className="text-[13px] text-[#4E4E4E] mb-5">
          From desert safaris to city adventures, our tours offer tailored experiences for every traveller. Enjoy top tours with trusted guides and seamless planning.
        </p>

        <Link
          to="/tour"
          className="inline-block bg-[#ff9219] text-white py-2 px-4 rounded-[4px] font-medium hover:bg-slate-400 transition-all duration-300 ease-in-out"
        >
          VIEW Tours
        </Link>
      </div>

    </div>
  );
}
